import { render, staticRenderFns } from "./ShareAudio.vue?vue&type=template&id=861e5eb4&scoped=true"
import script from "./ShareAudio.vue?vue&type=script&lang=js"
export * from "./ShareAudio.vue?vue&type=script&lang=js"
import style0 from "./ShareAudio.vue?vue&type=style&index=0&id=861e5eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861e5eb4",
  null
  
)

export default component.exports